<template>
  <div id="train">
    <div class="Lvone_tab">
      <div v-for="(item, index) in tabOneList" :key="index">
        <div class="Onetabtext" :class="{ 'Onetabtext_1': index == Onetabtindex }"
          @click="oneClick(index, item.id, item.type)">{{ item.name }}</div>
      </div>

    </div>
    <div class="voice" style="position: relative;">
      <div class="tabBox">
        <!--tabTow,二级tab在此-->
        <div class="index_tabBox"
          :class="{ 'index_tabBox_after': key == tabIndex, 'index_tabBox_left': key != 0 && key != tabTwoList.length - 1, 'index_tabbox_0': key == 0, 'index_tabbox_last': key == tabTwoList.length - 1, 'index_tabbox_fristss': key == 0 && tabTwoList.length - 1 == 0 }"
          v-for="(t, key) in tabTwoList" :key="key" @click="changeSecondaryTab(key, t.categoryId, t)">
          {{ t.categoryName }}
        </div>
        <a v-if="showAskingDoor"
          style="position: absolute; top: 14px; right: 20px; z-index: 9;" target="_blank"
          :href="imUrl + '/TJ_TJK_IMAction.html?token=' + imToken + '&tjkId=' + tjkInfo.id + '&userName=' + tjkInfo.realName + '&tjkNumber=' + tjkInfo.tjkNum + '&platform=assitant'">
          <img src="@/assets/images/zx.png" style="height: 30px;" alt="">
        </a>
      </div>

      <div class="main-content">
        <div v-if="newPeopleBadgeId == false">
          <el-dialog title="注意" :visible.sync="dialogVisible" width="30%" :show-close=false
            :close-on-click-modal="false">
            <span>完成前面的《系统测试》，才能报名技能提升培训</span>
            <span slot="footer" class="dialog-footer">
              <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <template
          v-if="assitantType != 'VoiceUpgradeSkill' && assitantType != 'OnlineUpgradeSkill' && assitantType != 'TjCollegeYingxiao' && assitantType != 'FbtOperate'">
          <div class="step-list other-list" v-for="(c, key) in courseList" :key="key">
            <div
              :class="{ step: true, active: c.passState == 'Passed', progress: c.passState == 'Ongoing' || c.passState == null }">
              <div class="circle" v-if="courseList.length != 1"
                :class="{ circle: c.passState == 'Passed', othercircle: c.passState == 'Ongoing' || c.passState == null }">
                <div v-if="courseList.length != 1">{{ key + 1 }}</div>
              </div>
              <div v-if="key != 0" class="top_line"
                :class="{ 'top_isCheck': c.passState == 'Passed' || c.passState == 'Ongoing', 'top_noCheck': c.passState == null }">
              </div>
              <div v-if="courseList.length > 1 && key != courseList.length - 1"
                :class="{ line: c.passState == 'Passed', otherline: c.passState == 'Ongoing' || c.passState == null }">
              </div>
            </div>
            <div class="content">
              <div class="box boxstyle">
                <div class="title">
                  <div>
                    <span class="name">{{ c.courseName }}</span>
                  </div>
                  <template v-if="c.unlock">
                    <div :class="c.passState == 'Passed' ? 'isgreen' : 'isred'">{{c.passState == "Passed" ? "已完成" : "未完成"}}</div>

                    <div class="test-button isposition">
                      <el-button @click="toStudy(c)"
                        v-if="(c.assitantType == null || c.assitantType == '' || c.assitantType == 'allSaleExam'|| c.assitantType == 'fbt') && c.courseType == 'Integrate' && c.passState != 'Passed'"
                        type="primary" size="small">点击学习</el-button>

                      <el-button @click="toStudy(c)"
                        v-if="(c.assitantType == null || c.assitantType == '' || c.assitantType == 'allSaleExam'|| c.assitantType == 'fbt') && c.courseType == 'Integrate' && c.passState == 'Passed'"
                        type="primary" size="small">重新学习</el-button>
                      <el-button @click="toStudy(c)" v-if="c.courseType == 'Exam' && c.passState != 'Passed'"
                        type="primary" size="small">开始测试</el-button>
                      <el-button @click="toStudy(c)" v-if="c.courseType == 'Exam' && c.passState == 'Passed'"
                        type="primary" size="small">重新测试</el-button>
                      <el-button @click="goCompleteExperience(c)"
                        v-if="c.courseType != 'Exam' && c.assitantType == 'fbtExamCourse'" type="primary" size="small">
                        {{ c.gainBadge == true ? '修改经验' :
                        '去完善'}}<!--为了不扰乱屎山，设定【FBT-结业考试】课程和【完善经验】都是fbtExamCourse，就是为了跳转和条件控制方便-->
                      </el-button>
                      <el-button @click="toStudy(c)" v-if="c.assitantType == 'urlLink' && c.unlock == true" type="primary"
                        size="small">点击跳转</el-button>
                      <el-button @click="toStudy(c)"
                        v-if="c.assitantType == 'AssitantSpecialRobotExam' && c.retry == 'false' && c.passState != 'Passed'"
                        size="small" type="primary">开始测试</el-button>
                      <el-button @click="toStudy(c)"
                        v-if="c.assitantType == 'AssitantSpecialRobotExam' && c.retry == 'true' && c.passState != 'Passed'"
                        size="small" type="primary">开始测试</el-button>
                      <el-button @click="toStudy(c)" v-if="c.assitantType == 'WordInputExam' && c.passState != 'Passed'"
                        type="primary" size="small">点击测试</el-button>
                      <el-button @click="toStudy(c)" v-if="c.assitantType == 'WordInputExam' && c.passState == 'Passed'"
                        type="primary" size="small">重新测试</el-button>
                      <el-button @click="toStudy(c)"
                        v-if="(c.assitantType == null || c.assitantType == '') && c.courseType == 'Linkage' && c.passState != 'Passed'"
                        type="primary" size="small">点击学习</el-button>
                      <el-button @click="toStudy(c)"
                        v-if="(c.assitantType == null || c.assitantType == '') && c.courseType == 'Linkage' && c.passState == 'Passed'"
                        type="primary" size="small">重新学习</el-button>

                      <!-- 在线--进入售前实操 -->
                      <el-button @click="goStudy(c)"
                        v-if="c.passState == 'Ongoing' && (c.assitantType == 'beforeSaleExam' || c.assitantType == 'afterSaleExam') && c.unlock == true"
                        type="primary" size="small">点击学习</el-button>
                      <el-button @click="goStudy(c)"
                        v-if="c.passState == 'Passed' && (c.assitantType == 'beforeSaleExam' || c.assitantType == 'afterSaleExam') && c.unlock == true"
                        type="primary" size="small">重新学习</el-button>
                    </div>

                  </template>

                  <template v-else>
                    <!-- <div class="el-icon-lock"></课程说明：> -->
                    <div class="lock"></div>
                  </template>
                </div>
                <div v-if="c.courseType == 'Integrate' || c.courseType == 'Linkage'" class="text textstyle">
                  课程说明：
                  <div style="width:70%;" v-if="c.result">{{ c.description }}<span class="thespan" v-if="c.result">({{ c.result }})</span> </div>
                  <div style="width:70%;" v-html="c.description" v-else></div>
                </div>
                <div v-if="c.courseType == 'Exam'" class="text textstyle" v-html="'完成要求：' + c.description"></div>
              </div>
            </div>
          </div>
        </template>
        <!--在线技能提升模块-->
        <template v-if="assitantType == 'OnlineUpgradeSkill'">
          <div class="RegistrationSessions" v-for="(item, index) in Onlinelist" :key="index">
            <div class="label" v-if="item.trainFlag == 'theory'">理论培训</div>
            <div class="label" v-if="item.trainFlag == 'exercise'">实操培训</div>
            <div class="text_box">
              <div class="title_state_button">
                <div class="title_state">
                  {{ item.trainTitle }}
                  <div v-if="item.passState != 'signTimeOut'"
                    :class="{ 'Reg_isred': item.passState != 'passed' && item.passState != 'signTimeOut', 'Reg_isgreen': item.passState == 'passed' }">
                    {{ item.passState != 'passed' && item.passState != 'signTimeOut' ? '未完成' : '已完成' }}
                  </div>
                </div>
                <div class="Reg_button" @click="togoscene(item)" v-if="item.passState == 'noJoin'">点击报名</div>
                <!--<div class="Reg_button" @click="gotest(item)" v-else-if="item.passState != 'signTimeOut'">进入学习</div>-->
                <div class="Reg_button_noqian" v-else-if="item.passState == 'alreadyApply'" @click="alertTrainNoStartOnline(item.startTime)">等待培训</div>
                <div class="Reg_button special_button" @click="gotest(item)" v-else-if="item.passState != 'signTimeOut'">点击学习</div>

                <!--<div class="Reg_button" @click="gotest(item)"
                  v-if="item.passState == 'goTest' && item.trainFlag == 'theory'">点击测试</div>
                <div class="Reg_button" @click="gotest(item)"
                  v-if="item.passState == 'goTest' && item.trainFlag == 'exercise'">点击练习</div>
                <div class="Reg_button" @click="gotest(item)"
                  v-if="item.passState == 'passed' && item.trainFlag == 'theory'">重新测试</div>
                <div class="Reg_button" @click="gotest(item)"
                  v-if="item.passState == 'passed' && item.trainFlag == 'exercise'">重新练习</div>
                <div class="Reg_button" @click="GoOnlineSignIn(item)"
                  v-if="item.passState != 'goTest' && item.passState != 'noJoin' && item.passState != 'signTimeOut' && item.passState != 'passed'">
                  点击签到</div>
                <div class="Reg_button_noqian" v-if="item.passState == 'noSignedNoOpen'">点击签到</div>-->
              </div>


              <!--<div class="Reg_date" v-if="item.trainFlag == 'theory'">
                培训日期：{{ item.trainDate }}
              </div>
              <div class="Reg_time" v-if="item.trainFlag == 'theory'">
                培训时间：<span v-for="(m, key) in item.trainTime" :key="key">{{ m }}<span
                    v-if="key < item.trainTime.length - 1">，</span></span>
              </div>
              <div class="Reg_lecturer" v-if="item.trainFlag == 'theory'">
                培训讲师：{{ item.teacherName }}
              </div>-->

              <div class="Reg_date" v-if="item.trainFlag == 'exercise' || item.trainFlag == 'theory'">
                培训时间：{{ item.startTime }}-{{ item.endTime }}
              </div>
              <div class="Reg_lecturer" v-if="item.trainFlag == 'exercise' || item.trainFlag == 'theory'">
                培训模式：在线自学讲师帮扶
              </div>

              <div class="Reg_qq"
                v-if="item.passState != 'passed' && item.passState != 'signTimeOut' && item.passState != 'noJoin'">
                问题咨询： {{ item.qqNumber }}
              </div>
              <div class="Reg_content">培训内容：{{ item.trainContent }}</div>
              <div class="fail_img" v-if="item.passState == 'signTimeOut'"><img src="../../assets/images/fail.png" alt="">
                <div class="fail_text">已失效</div>
              </div>
            </div>
          </div>
          <el-dialog title="" :visible.sync="addGroupDialog.show" width="360px" :show-close='false'
            :close-on-click-modal='false'>
            <div class="dialog_img"><img src="../../assets/images/voiceScene/icon_tips.png" alt=""></div>
            <div class="qq_text">确认参加培训并加入培训群</div>
            <span slot="footer" class="dialog-footer">
              <div class="currency_button">
                <div class="cancel" @click="addGroupDialog.show = false">取消</div>
                <div class="determine" @click="isenlist">确定</div>
              </div>
            </span>
          </el-dialog>
          <el-dialog title="" :visible.sync="dimensional" width="360px" :close-on-click-modal='false' center>
            <div class="dimensionalimg_Line"></div>
            <div class="dialog_img" style="margin-top:50px;"><img src="../../assets/images/voiceScene/icon_tips.png"
                alt=""></div>
            <span slot="footer" class="dialog-footer">
              <div class="dimensionalimg_text">你已成功报名</div>
              <div class="cel-button" @click="qqsceneId">进入培训群</div>
            </span>
          </el-dialog>

        </template>
        <!--语音技能提升模块-->
        <template v-if="assitantType == 'VoiceUpgradeSkill'">
          <div class="RegistrationSessions" v-for="(item, index) in cseList" :key="index">
            <!--已签到状态：卡片右上角-->
            <div class="live_signed_badge"
              v-if="item.mode=='live' && item.sign=='Yes' && item.passState!='signTimeOut'">已签到</div>
            <div class="text_box">
              <div class="title_state_button">
                <div class="title_state">
                  {{ item.trainTitle }}
                  <div v-if="item.passState != 'signTimeOut' && item.passState != 'noJoin'"
                    :class="{ 'Reg_isred': item.passState != 'passed' && item.passState != 'signTimeOut', 'Reg_isgreen': item.passState == 'passed' }">
                    {{ item.passState != 'passed' && item.passState != 'signTimeOut' ? '未完成' : '已完成' }}
                  </div>
                </div>

                <!--自学模式-->
                <div v-if="item.mode=='self'">
                  <div class="Reg_button" @click="goscene(item)" v-if="item.passState == 'noJoin'">点击报名</div>
                  <div class="Reg_button special_button" @click="regoscene(item.sceneId, item.trainId)"
                    v-if="item.passState != 'noJoin' && item.passState != 'passed' && item.passState != 'signTimeOut'">
                    点击学习</div>
                  <div class="Reg_button" @click="regoscene(item.sceneId, item.trainId)" v-if="item.passState == 'passed'">
                    重新学习</div>
                  <!--<div class="Reg_button" @click="signIn(item.sceneId, item.trainId)" v-if="item.passState == 'noSignAlreadyOpen'">点击签到</div>
                  <div class="Reg_button_noqian" v-if="item.passState == 'noSignedNoOpen'">点击签到</div>-->
                </div>

                <!--直播模式：已签到徽章在右上角、操作按钮在右下角，见下方 live_signed_badge / live_btns-->


              </div>
              <div class="Reg_date">
                培训日期：{{ item.startTime }}-{{ item.endTime }}
              </div>
              <div class="Reg_time">
                培训时间：<span v-for="(m, key) in item.trainTime" :key="key">{{ m }}<span
                    v-if="key < item.trainTime.length - 1">，</span></span>
              </div>
              <!--<div class="Reg_lecturer">
                培训讲师：{{ item.teacherName }}
              </div>
              <div class="Reg_qq"
                v-if="item.passState != 'passed' && item.passState != 'signTimeOut' && item.passState1 != 'noJoin' && item.passState != 'noJoin'">
                培训群：{{ item.qqNumber }}
              </div>-->
              <div class="Reg_content">培训内容：{{ item.trainContent }}</div>
              <!--直播模式操作按钮：卡片右下角-->
              <div class="live_btns" v-if="item.mode=='live'">
                <!--报名前-->
                <div class="Reg_button" @click="goscene(item)" v-if="item.passState == 'noJoin'">点击报名</div>
                <!--报名后未签到-->
                <div class="Reg_button" @click="liveSignIn(item)"
                  v-if="item.passState != 'noJoin' && item.passState != 'signTimeOut' && item.sign != 'Yes'">点击签到</div>
                <!--签到成功后：进入培训-->
                <div class="Reg_button special_button" @click="regoscene(item.sceneId, item.trainId)"
                  v-if="item.passState != 'noJoin' && item.passState != 'signTimeOut' && item.sign == 'Yes'">进入培训</div>
              </div>
              <div class="fail_img" v-if="item.passState == 'signTimeOut'"><img src="../../assets/images/fail.png" alt="">
                <div class="fail_text">已失效</div>
              </div>
            </div>
          </div>
          <el-dialog title="" :visible.sync="addGroupDialog.show" width="360px" :show-close='false'
            :close-on-click-modal='false'>
            <div class="dialog_img"><img src="../../assets/images/voiceScene/icon_tips.png" alt=""></div>
            <div class="qq_text">确认参加培训并加入培训群</div>
            <span slot="footer" class="dialog-footer">
              <div class="currency_button">
                <div class="cancel" @click="addGroupDialog.show = false">
                  取消
                </div>
                <div class="determine" @click="isenlist">
                  确定
                </div>
              </div>
            </span>
          </el-dialog>
          <el-dialog title="" :visible.sync="dimensional" width="360px" :close-on-click-modal='false' center>
            <div class="dimensionalimg_Line"></div>
            <div class="dimensionalimg"><img :src="dimensionalimg" alt=""></div>
            <div class="dimensionalimg_text">请使用手机QQ扫一扫加入培训群</div>
            <span slot="footer" class="dialog-footer">
              <div class="cel-button" @click="qqsceneId">已扫码加入</div>
            </span>
          </el-dialog>

        </template>
        <!--淘金大学营销模块-->
        <template v-if="assitantType == 'TjCollegeYingxiao'">
          <div class="RegistrationSessions" v-for="(item, index) in cseList" :key="index">
            <div class="text_box">
              <div class="title_state_button">
                <div class="title_state">
                  {{ item.trainTitle }}
                  <div v-if="item.passState != 'signTimeOut' && item.passState != 'noJoin'"
                    :class="{ 'Reg_isred': item.passState != 'passed' && item.passState != 'signTimeOut', 'Reg_isgreen': item.passState == 'passed' }">
                    {{ item.passState != 'passed' && item.passState != 'signTimeOut' ? '未完成' : '已完成' }}
                  </div>
                </div>


                <div class="Reg_button" @click="goscene(item)" v-if="item.passState == 'noJoin'">点击报名</div>
                <div class="Reg_button special_button" @click="regoscene(item.sceneId, item.trainId)"
                  v-if="item.passState != 'noJoin' && item.passState != 'passed' && item.passState != 'noSignAlreadyOpen' && item.passState != 'noSignedNoOpen' && item.passState != 'signTimeOut'">
                  点击学习</div>
                <div class="Reg_button" @click="regoscene(item.sceneId, item.trainId)" v-if="item.passState == 'passed'">
                  重新学习</div>
                <div class="Reg_button" @click="signIn(item.sceneId, item.trainId)"
                  v-if="item.passState == 'noSignAlreadyOpen'">点击签到</div>
                <div class="Reg_button_noqian" v-if="item.passState == 'noSignedNoOpen'">点击签到</div>
              </div>
              <div class="Reg_date">
                培训日期：{{ item.trainDate }}
              </div>
              <div class="Reg_time">
                培训时间：<span v-for="(m, key) in item.trainTime" :key="key">{{ m }}<span
                    v-if="key < item.trainTime.length - 1">，</span></span>
              </div>
              <div class="Reg_lecturer">
                培训讲师：{{ item.teacherName }}
              </div>
              <div class="Reg_qq">
                企业微信群：{{ item.groupName }}
              </div>
              <div class="Reg_content">培训内容：{{ item.trainContent }}</div>
              <div class="fail_img" v-if="item.passState == 'signTimeOut'"><img src="../../assets/images/fail.png" alt="">
                <div class="fail_text">已失效</div>
              </div>
            </div>
          </div>
          <el-dialog title="" :visible.sync="addGroupDialog.show" width="360px" :show-close='false'
            :close-on-click-modal='false'>
            <div class="dialog_img"><img src="../../assets/images/voiceScene/icon_tips.png" alt=""></div>
            <div class="qq_text">{{ addGroupDialog.tip }}</div>
            <span slot="footer" class="dialog-footer">
              <div class="currency_button">
                <div class="cancel" @click="addGroupDialog.show = false">
                  取消
                </div>
                <div class="determine" @click="isenlist">
                  确定
                </div>
              </div>
            </span>
          </el-dialog>
          <el-dialog title="" :visible.sync="dimensional" width="360px" :close-on-click-modal='false' center>
            <div class="dimensionalimg_Line"></div>
            <div class="dialog_img" style="margin-top:50px;"><img src="../../assets/images/voiceScene/icon_tips.png"
                alt=""></div>
            <span slot="footer" class="dialog-footer">
              <div class="dimensionalimg_text">你已成功报名</div>
              <div class="cel-button" @click="qqsceneId">进入培训群</div>
            </span>
          </el-dialog>

        </template>
        <!--淘系实操模块-->
        <template v-if="assitantType == 'FbtOperate'">
          <trainList :categoryId="categoryId"></trainList>
        </template>
      </div>
    </div>

    <el-dialog title="考核次数" :visible.sync="theoryRemainDialog.show" width="360px">
      <el-form>
        <el-form-item label="总考核次数" label-width="150px">
          <el-link type="primary" @click="editRow(scope.row)" :underline="false">{{ theoryRemainDialog.total }}</el-link>
        </el-form-item>
        <el-form-item label="剩余考核数" label-width="150px">
          <el-link type="primary" @click="editRow(scope.row)" :underline="false">{{ theoryRemainDialog.remain }}</el-link>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="currency_button">
          <div class="cancel" @click="theoryRemainDialog.show = false">取消</div>
          <div class="determine" @click="goThoryExamPage">确定</div>
        </div>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import voice from "./voice";
import examDialog from "./examDialog";
import trainList from "./FBT/trainList";
export default {
  data() {
    return {
      tjkInfo: {},
      toptab: '语音技能提升', //语音or在线
      tabIndex: 0,
      showAskingDoor: false,//是否展示咨询入口
      tabOneList: [], //一级table
      tabType: null, //二级tab菜单名称
      tabTwoList: [], //二级tab菜单
      tabMajorId: this.$route.query.tabMajorId, //tab的id
      courseList: [],
      trainList: [],
      examCourseId: null, //测试考试课程id
      trainState: null, //技能提升是否获得徽章
      badgeUrl: "", //获得徽章图片地址
      content: "", //获得徽章文字描述
      description: "", //场景文字描述
      isAllComplete: 0,
      registration: 0,   //判断是否报名
      trainList: [],   //查看报名页面
      decide: 0,//判断场景完成状态
      isPost: false,  //判断有无上岗徽章
      newPeopleBadgeId: false, //判断有无语音新人徽章
      isaxx: 0,
      dialogVisible: false, //控制是否完成之前任务弹窗
      needFinish: null,  //系统操作和任务指南完成情况
      systemPopup: false, //没有完成系统实操弹窗
      iskey: null,            //存页面tab现展示的key
      istype: '',      //保留当前页面type
      axx: false,
      issystem: false,       //判断系统实操是否完成
      prosystemPopup: false,   // 系统实操页面弹窗
      dimensional: false,   //二维码弹窗
      dimensionalimg: '', //二维码url
      majorId: 100037, //一级tab的majorId,待改
      categoryId: 1071,//点击二级tab显示页面
      cseList: [],
      assitantType: '',//判断二级目录是否是特殊目录（类似技能提升
      sceneId: null,//场景id
      addGroupDialog: {
        show: false,//是否报名弹窗（qq弹窗之前）
        majorType: null,//是否是淘金大学类型【VOICE/TjCollege】
        tip: '确认参加培训并加入培训群',
      },
      trainId: null,//场次id
      OnlinetrainId: null,//在线场次id
      tjkId: null,//淘金客id
      prosper: false,//排班状态（成功、失败）
      AppGuide: false,//app引导弹窗
      Onetabtindex: 0,
      Onlinelist: [],//在线技能提升列表
      OnlinesignIn: false,//在线点击报名
      trainTitle: '',//场次名字
      VoicePassState: '',//报名页面按钮状态passState
      curriculum: {},//课程
      theoryRemainDialog: {
        show: false,
        courseIdOfsceneId: null,
        passState: null,
        total: null,
        remain: null
      },
      imUrl: API_ROOT.imUrl,
            imToken: API_ROOT.imToken
    };
  },
  components: {
    voice,
    examDialog,
    trainList
  },
  watch: {},
  created() {
    // if (!window.myTaojinWebBrower && !this.$route.query.ht) {
    //   alert('请在小助手中打开此页面！')
    //   return
    // }
    // this.getCustomerUser();//查当前客服

    if (this.$route.query.type == 'SkillUpgrade') {
      this.isspecial()
      this.Lv3Courses()
    }
    else if (localStorage.getItem('tabIndex') || localStorage.getItem('majorId')) {
      var i = localStorage.getItem('tabIndex')
      i = Number(i)
      this.tabIndex = i
      var n = localStorage.getItem('Onetabtindex')
      n = Number(n)
      this.Onetabtindex = n
      this.majorId = localStorage.getItem('majorId')

      this.categoryId = localStorage.getItem('categoryId')
      this.LevelOneTab(i)
      if (this.$route.query.condition == 'false') {
        this.assitantType = 'VoiceUpgradeSkill'
        // this.$router.push({query: {}});
      }
    } else {
      this.LevelOneTab()
    }
    this.parent = this.$route.query.parent
    this.getCustomerUser()
  },
  methods: {
    alertTrainNoStartOnline(trainTime){
        this.$message({message: '该培训 '+trainTime+' 开始', type: 'warning', center: true, duration: 3500});
    },
    //(普通课程)点击学习点击重新学习
    async goStudy(c) {
      var courseId = c.courseId;
      var courseType = c.courseType;
      var assitantType = c.assitantType;
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: courseId }).then((res) => {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && courseType != "Exam") {
            var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
            this.$router.push({
              path: '/train/Secondarylist',
              query: { courseId: courseId, tjkId: this.tjkId, CourseLevel: 3, sceneId: this.sceneId, trainId: this.trainId, urlLink: url }
            })
          } else if (courseType == "Exam") {
            this.beginExam(c)
            this.examCourseId = courseId;
          } else {
            this.$router.push({
              path: "/vedioDetail",
              query: {
                courseId: courseId,
                knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                CourseLevel: 3,
                sceneId: this.sceneId,
                trainId: this.trainId,
                tjkId: this.tjkId,
                knowledgeId: result.data.knowledgeRecordFullList[0].knowledgeId
              }
            });
          }
        } else {
          this.$alert(result.msg);
        }
      }, (res) => {
        this.$alert(
          "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
        );
      }
      );
    },
    //切换一级tab
    oneClick(index, id, type) {
      this.Onetabtindex = index
      this.majorId = id
      this.assitantType = ''
      localStorage.removeItem('tabIndex')
      localStorage.removeItem('categoryId')
      localStorage.setItem('Onetabtindex', index)
      localStorage.setItem('CurrentMajorScope', type)
      this.tabIndex = 0
      this.SecondaryTab(0)
    },
    //  一级导航tab
    LevelOneTab(i) {
      this.$http.post(API_ROOT.college + "/majorAll/showTabMajor")
        .then((res) => {
          var result = res.data;
          if (result.success) {
            this.tabOneList = result.data
            if (localStorage.getItem('defaultShow')) {
              this.majorId = localStorage.getItem('majorId') ? localStorage.getItem('majorId') : this.tabOneList[0].id;
              this.SecondaryTab(i)
              //添加i修改两次锁定弹窗
            }
            else {
              this.tabOneList.forEach((item, index) => {
                if (item.defaultShow == true) {
                  localStorage.setItem('defaultShow', 1)
                  this.majorId = item.id
                  this.Onetabtindex = index
                  this.SecondaryTab(index)
                  //添加i修改两次锁定弹窗
                  localStorage.setItem('tabIndex', 0)
                  localStorage.setItem('Onetabtindex', index)
                }
              })
            }
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        }
        );
    },
    //二级获得目录tab
    SecondaryTab(i) {
      var self = this;
      this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk", { majorId: this.majorId }).then(
        (res) => {
          var result = res.data;
          if (result.success) {
            self.tabTwoList = result.data
            self.categoryId = this.tabTwoList[0].categoryId
            self.showAskingDoor = result.showAskingDoor

            var needSetDefaultTab2Tmp = true;
            if (localStorage.getItem('needSetDefaultTab2') == 'false') {
              localStorage.removeItem('needSetDefaultTab2');
              needSetDefaultTab2Tmp = false;
            }
            var tabIndex = result.tabIndex;
            var categoryId = result.categoryId;

            if (needSetDefaultTab2Tmp == false && self.tabTwoList && self.$route.query.tabIndex) {
              var routeTabIndex = Number(self.$route.query.tabIndex);
              routeTabIndex = routeTabIndex > self.tabTwoList.length ? 0 : routeTabIndex;
              tabIndex = routeTabIndex;
              categoryId = self.tabTwoList[routeTabIndex].categoryId;
            }
            self.changeSecondaryTab(tabIndex, categoryId);

            var tabname = this.tabTwoList[0].categoryName
            localStorage.setItem('majorId', this.majorId)
            if (localStorage.getItem('categoryId')) {
              self.categoryId = localStorage.getItem('categoryId')
            }

            if (localStorage.getItem('CurrentMajorScope') == 'PreworkOnlineExerciseDirect') {
              self.assitantType = 'PreworkOnlineExerciseDirect'
              localStorage.setItem('assitantType', 'PreworkOnlineExerciseDirect');
            }
          } else {
            self.$alert(result.msg);
            self.tabTwoList = []
            self.courseList = []
          }
        },
        (res) => {
          this.$alert(
            "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
          );
        }
      );
    },
    //特殊弹窗点击报名（刚打开小助手弹报名窗）
    isspecial() {
      this.$http.post(API_ROOT.college + "/majorAll/showTabMajor")
        .then((res) => {
          var result = res.data;
          if (result.success) {
            this.tabOneList = result.data
            this.majorId = this.tabOneList[0].id
            localStorage.setItem('majorId', this.majorId)
            this.specialtwotab()
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert(
            "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
          );
        }
        );
    },
    //特殊弹窗，小助手弹窗查询二级tab
    specialtwotab() {
      this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk", { majorId: this.majorId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.tabTwoList = result.data
              this.tabIndex = 0
              localStorage.setItem('tabIndex', 0)
              this.categoryId = this.tabTwoList[0].categoryId
              localStorage.setItem('categoryId', this.categoryId)
              localStorage.setItem('tabname', this.tabTwoList[0].categoryName)
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
    /**
     * 点击二级tab
     * needSetDefaultTab2 是否需要默认的定位高亮，若是点击的一级tab，需要定位到合适的二级tab，这情况当做是需要定位
     * */
    changeSecondaryTab(tabTwoIndex, categoryId) {
      var tabTwoObj = this.tabTwoList[tabTwoIndex];
      if (this.tabTwoList.length != 1) {
        this.courseList = []
        this.assitantType = tabTwoObj.assitantType

        this.tabIndex = tabTwoIndex
        this.categoryId = categoryId;
        localStorage.setItem('categoryId', categoryId)
        localStorage.setItem('tabIndex', tabTwoIndex)

        var self = this;
        if (this.assitantType == 'VoiceUpgradeSkill') {
          this.getTrainList()
        } else if (this.assitantType == 'OnlineUpgradeSkill') {
          this.OnlinePromote()
        } else if (this.assitantType == 'TjCollegeYingxiao') {
          this.getTjCollegeTrainList('yingxiao')
        } else if (this.assitantType == 'FbtOperate') {
        } else {
          this.Lv3Courses();
        }
      } else if (this.tabTwoList.length == 1) {
        //路径下直接课程列表，如：【在线实操直通车】、【办公软件学习】
        this.Lv3Courses();
      }
    },


    /**
     * 三级课程
     * @param needSetDefaultTab2 手动tab切换，区别于默认自定位tab2，因为Lv3Courses里会根据末尾课程的结果 和 needSetDefaultTab2 联合决定是否强行定位到默认tab
     * */
    Lv3Courses() {
      var self = this;
      this.$http.post(API_ROOT.college + "/majors/queryCourseViewNewXlkCategoryId", { categoryId: this.categoryId })
        .then((res) => {
          var result = res.data;
          if (result.success) {
            this.courseList = result.data.courseViewList;
            this.curriculum = result.data
            if (result.msg != null) {
              this.$alert(result.msg)
            }

            //如果tab末尾课程已通关，则自动定位到下一个 二级tab高亮(如 技能提升)
            // if(this.courseList && this.courseList.length>0 && needSetDefaultTab2 == true){
            //     var showNextTabTwo = self.courseList[self.courseList.length-1].passState == 'Passed';
            //     if(showNextTabTwo && self.tabIndex < self.tabTwoList.length-1){
            //         self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
            //         self.tabIndex++;
            //         self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
            //     }
            // }
          } else {
            if (result.msg != '课程记录列表不能为空') {
              this.$alert(result.msg);//因为需要查看课程列表所以屏蔽
              this.courseList = []
              this.Onlinelist = []
              this.cseList = []
            }
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        }
        );
    },
    getCustomerUser() {
      this.$http.get('/customer/action/currentUser/customerUser').then(response => {
        var result = response.data;
        if (result.success) {
          this.tjkInfo = result.data;
        } else {
          this.$alert(result.msg);
        }
      }, response => {
        this.$alert('AJAX访问接口异常！');
      })
    },
    //在线技能提升
    OnlinePromote() {
      var self = this;
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTrainListOnline",).then((res) => {
        var result = res.data;
        if (result.success) {
          this.Onlinelist = result.data.trainList
          //若存在已完成，则则跳下一个
          // if(needSetDefaultTab2){
          //     for (var i of result.data.trainList) {
          //         if(i.trainFlag == 'exercise' && i.passState == 'passed' && self.tabIndex < self.tabTwoList.length-1){
          //             self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
          //             self.tabIndex++;
          //             self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
          //             break;
          //         }
          //     }
          // }
        } else {
          if (result.msg != '课程记录列表不能为空') {
            this.$alert(result.msg);//因为需要查看课程列表所以屏蔽
          }
        }
      },
        (res) => {
          this.$alert(
            "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
          );
        }
      );
    },
    // 进入考试,
    beginExam(c) {
      var trainFlag = null;
      if (c.assitantType == 'fbtExamCourse') {
        trainFlag = 'fbtTrain'
      }
      if (localStorage.getItem('CurrentMajorScope') == 'PreworkOnlineExerciseDirect') {
        trainFlag = 'PreworkOnlineExerciseDirect';//只要不是theory,就不会提示说，接下来学习下一阶段
        this.assitantType = 'PreworkOnlineExerciseDirect';
      }
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + c.courseId + '&trainFlag=' + trainFlag + '&assitantType=' + this.assitantType + '&tabIndex=' + this.tabIndex;
    },
    //报名页面进入场景页面
    // 点击签到
    signIn(id, trainId) {
      this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign", {
        trainId: trainId,

      })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.sceneId = id
              this.trainId = trainId
              this.$router.push({
                path: '/train/SpecialCourses', query: {
                  sceneId: this.sceneId,
                  trainId: this.trainId,
                  tjkId: this.tjkId
                }
              })
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
          }
        );
    },
    // 直播模式签到：签到成功后不跳转，给出反馈并原地切换为已签到
    liveSignIn(item) {
      this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign", {
        trainId: item.trainId
      })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.$message({ message: '签到成功', type: 'success', center: true, duration: 1000 });
              this.$set(item, 'sign', 'Yes');
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
          }
        );
    },
    // 重新学习
    regoscene(id, trainId) {
      this.sceneId = id
      this.trainId = trainId
      this.$router.push({
        path: '/train/SpecialCourses', query: {
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId,
          assitantType: this.assitantType
        }
      })
    },
    //点击报名
    goscene(item) {
      this.addGroupDialog.show = true
      this.addGroupDialog.tip = item.majorType == 'VOICE' ? '确认参加培训并加入培训群' : '确认参加培训并加入企业微信群',
      this.addGroupDialog.majorType = item.majorType
      this.sceneId = item.sceneId
      this.trainId = item.trainId
      this.VoicePassState = item.passState
      this.sign = item.sign
      this.teamtalkGroupId = item.teamtalkGroupId
      this.dimensionalimg = item.qqImg;
      debugger
    },

    //在线————点击报名
    togoscene(item) {
      this.addGroupDialog.show = true
      this.OnlinesignIn = true
      this.OnlinetrainId = item.trainId
      this.trainId = item.trainId
      this.trainTitle = item.trainTitle
      this.jumpGroupLink = item.groupLink
      this.teamtalkGroupId = item.teamtalkGroupId
    },

    //--在线点击测试
    gotest(row) {
      if (row.trainFlag == 'theory' || row.trainFlag == 'exercise') {
          this.$router.push({
              path: '/train/SpecialCourses',
              query: { "sceneId": row.sceneId, assitantType: this.assitantType, trainFlag: row.trainFlag }
          })

      }
    },
    goThoryExamPage() {
      if (this.theoryRemainDialog.remain <= 0) {
        if (this.theoryRemainDialog.passState == 'passed') {
          this.$message({ message: '今日次数已用完，请明日再来', type: 'warning', center: true, duration: 2500 });
        } else {
          this.$message({ message: '考核次数已用完，请报名下一场', type: 'warning', center: true, duration: 2500 });
        }
        return;
      }
      window.location.href = '/tjkStudy/train/examDetail?trainFlag=theory&courseId=' + this.theoryRemainDialog.courseIdOfsceneId + '&assitantType=' + this.assitantType;
    },

    //--在线理论和实操点击签到
    GoOnlineSignIn(item) {
      if (item.trainFlag == 'exercise') {
        this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign?", { trainId: item.trainId })
          .then(
            (res) => {
              var result = res.data;
              if (result.success) {
                this.$message({ message: '签到成功', type: 'success', center: true, duration: 1000 });
                this.OnlinePromote()
              } else {
                this.$alert(result.msg);
              }
            }, (res) => {
              this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
            }
          );
      } else if (item.trainFlag == 'theory') {
        this.$router.push({
          path: '/train/Sessions',
          query: { trainId: item.trainId, trainTitle: item.trainTitle, trainContent: item.trainContent }
        })
      }
    },

    //进入培训群qq群进入场景页面
    isenlist() {
      var self = this;
      if (this.OnlinesignIn) {
        this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/applyTrain", {
          trainId: this.trainId,
        }).then((res) => {
          var result = res.data;
          if (result.success) {
            this.dimensional = true
            this.addGroupDialog.show = false
            this.OnlinePromote();
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/preWorkOnlineTrain/applyTrain）！");
        })
      } else if (this.addGroupDialog.majorType == 'VOICE') {
        this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrainIntegrate", {
          trainId: this.trainId,
        }).then((res) => {
          var result = res.data;
          if (result.success) {
              //加群二维码图片
              this.dimensional = true
              this.addGroupDialog.show = false
              this.dimensionalimg = result.data.qqImg;//这里再设置一次，是为了避免出现图片没加载出来的情况
              debugger
              var mode = result.data.mode;     //self-自学，live-直播
              //如果是自学模式,就直接刷新,跳小助手, 若是直播live模式,还要弹出q群二维码
              if(mode == 'self'){
                this.qqsceneId()
              }
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        })
      } else {
        this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrain", { trainId: this.trainId, channel: 'assitant' }).then((res) => {
          var result = res.data;
          if (result.success) {
            this.addGroupDialog.show = false;
            this.getTjCollegeTrainList('yingxiao');
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        })
      }
    },

    qqsceneId() {
      //判断是否是小助手，如是小助手，则跳 “消息”模块，判断有没有填写teamtalk群号，填了就跳
      this.dimensional = false
      //刷新先
      if (this.OnlinesignIn) {
        this.OnlinePromote()
      } else {
        this.getTrainList()
      }

      if (this.teamtalkGroupId) {
        this.$http.get(`http://127.0.0.1:26688/api/TjHawkeye/switchMenu?menu=消息&id=${this.teamtalkGroupId}`).then((res) => { })
      }

    },
    sign_upo() {
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=no';
    },
    sign_up() {
      localStorage.setItem('trainState', 'no')
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
    },
    // 去报名
    Gosignup() {
      if (this.registration == null || 0) {
        window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
      }
    },

    handleClick(tab, event) {
      this.tabOneList.forEach((item, index) => {
        if (tab.name == item.name) {
          this.majorId = item.id
        }
      })
    },
    //在线客服-视频观看记录
    saveTjkTrainInfoOnline() {
      this.$http.post(API_ROOT.college + "/assitantTrain/saveWebLoginAndAssitantDown", {
        tDisplayVideo: "Yes",
      })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },

    getTabIndex() {
      for (let i = 0; i < this.tabTwoList.length; i++) {
        if (this.tabTwoList[i].type == this.tabType) {
          return i;
          break;
        }
      }
    },
    changeTab(key, type, id) {
      if (key == 2 && this.issystem == false) {
        if (this.axx == false) {
          if (this.iskey == 0) {
            this.tabType = 'SystemOperation'
            this.tabIndex = 0
            this.dialogVisible = true
          } else if (this.iskey == 1) {
            this.tabType = 'TaojinCulture'
            this.tabIndex = 1
            this.dialogVisible = true
          }
        } else {
          if (this.iskey == 1) {
            this.tabType = 'SystemOperation'
            this.tabIndex = 0
            this.dialogVisible = true
          }
        }
      } else if (this.issystem == false) {
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=TaojinCulture&tabMajorId=" + id + '&show=yes'
        } else {
          this.axx = true
          this.$set(this, "tabIndex", key);
          this.$set(this, "tabType", type);
        }
      }
      else if (this.issystem == true) {
        this.$set(this, "tabIndex", key);
        this.$set(this, "tabType", type);
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=" + type + "&tabMajorId=" + id + '&show=yes'
        }
      }
    },

    //获取技能提升列表
    getTrainList() {
      var self = this;
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTrainListVoice", {})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.cseList = result.data.trainList;
              this.newPeopleBadgeId = result.data.newPeopleBadgeId
              this.needFinish = result.data.needFinish
              this.tjkId = result.data.tjkId
              for (var i of self.trainList) {
                if (i.passState == 'signTimeOut' || (i.passState == 'examUnPassed' && i.passState != 'signTimeOut') || i.passState == 'noExam') {
                  this.registration = 0
                } else if (i.passState == 'passed') {
                  this.registration = 1
                  break
                }
                else if ((i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam') || (i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut')) {
                  this.registration = 1
                  break
                }
              }
              localStorage.setItem('registration', this.registration)
              this.trainState = result.data.trainState;
              if (localStorage.getItem('trainState') == 'no') {
                this.trainState = null
                localStorage.setItem('trainState', '')
              }
              this.content = result.data.content;

              // //若存在已完成，则则跳下一个
              // for (var i of self.cseList) {
              //     if(needSetDefaultTab2 && i.passState == 'passed' && self.tabIndex < self.tabTwoList.length-1){
              //         self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
              //         self.tabIndex++;
              //         self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
              //         break;
              //     }
              // }
            } else {
              this.$alert(result.msg);
            }
          }, (res) => {
            this.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
          }
        );
    },
    //获取淘金大学技能提升列表，type代表类型，如 营销
    getTjCollegeTrainList(type) {
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTjCollegeWeb", {})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.cseList = result.data.trainList;
              this.newPeopleBadgeId = result.data.newPeopleBadgeId
              this.needFinish = result.data.needFinish
              this.tjkId = result.data.tjkId
              for (var i of this.trainList) {
                if (i.passState == 'signTimeOut' || (i.passState == 'examUnPassed' && i.passState != 'signTimeOut') || i.passState == 'noExam') {
                  this.registration = 0
                } else if (i.passState == 'passed') {
                  this.registration = 1
                  break
                }
                else if ((i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam') || (i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut')) {
                  this.registration = 1
                  break
                }
              }
              localStorage.setItem('registration', this.registration)
              this.trainState = result.data.trainState;
              if (localStorage.getItem('trainState') == 'no') {
                this.trainState = null
                localStorage.setItem('trainState', '')
              }
              this.content = result.data.content;
            } else {
              this.$alert(result.msg);
            }
          }, (res) => {
            this.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
          }
        );
    },
    //调用小助手
    getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response => {
        var result = response.data;
      }, response => {

      })
    },
    //记录接口
    addRecord(type, index) {
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
        var result = res.data
        if (result.success) {

        } else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      }, res => {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
    applyTask() {
      this.$http.post(API_ROOT.college + '/badge/applyTaskApp').then(res => {
        var result = res.data
        if (result.success) {
          this.callHawkeye();
        } else {
          this.$alert(result.msg);
        }
      }, res => {
        loading.close();
        this.isDisable = false
        this.$alert("网络繁忙，请稍后重试！");
      })
    },
    goCompleteExperience(c) {
      //跳转到 经验选择
      this.$router.push({ path: '/train/fbtExperienceChoose', query: { tabIndex: this.tabIndex, courseId: c.courseId } });
    },
    /*async */
    toStudy(c) {
      var self = this;
      if (c.assitantType == 'urlLink') {
        var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
        this.$router.push({ path: '/train/Secondarylist', query: { courseId: c.courseId, tjkId: this.tjkId, CourseLevel: 3, urlLink: url } })
      } else if (c.assitantType == 'AssitantSpecialRobotExam') {
        if (c.status == 'NoTheoryBadge') {
          this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
          return;
        }
        this.applyTask();
        this.addRecord('START', 3);
      } else if (c.assitantType == 'WordInputExam') {
        this.$router.push({
          path: '/train/OnInline',
          query: {
            page: 'dazi',
            courseId: c.courseId,
            type: c.assitantType,
            knowledgeSeq: 1,
            theoryBadge: this.curriculum.theoryBadge//理论实操完成情况
          }
        })
      } else {
        this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: c.courseId }).then((res) => {
          var result = res.data;
          if (result.success) {
            if (c.assitantType == 'fbt' || (result.data.knowledgeRecordFullList.length != 1 && c.courseType != "Exam")) {
              //记录类型，传到对练系统，记录结果存到college里
              var collegeType = null;
              if (c.assitantType == 'allSaleExam' || c.assitantType == 'fbt') {
                collegeType = c.assitantType;
              }
              this.$router.push({ path: '/train/Secondarylist', query: { courseId: c.courseId, collegeType: collegeType } })
            } else if (c.courseType == "Exam") {
              // var trainFlag = '电商平台制度考核' == c.courseName ? null : 'theory';
              this.beginExam(c)
              this.examCourseId = c.courseId;
            } else {
              var knowledgeId = result.data.knowledgeRecordFullList[0].knowledgeId
              this.$router.push({
                path: "/vedioDetail",
                query: {
                  courseId: c.courseId,
                  knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                  knowledgeId: knowledgeId
                }
              })
            }
          } else {
            this.$alert(result.msg);
          }
        }, (res) => { this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"); }
        );
      }
    },
    //调用小助手引导功能
    callHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response => {
        var result = response.data;
      }, response => { })
    },
    //技能提升-报名
    joinTrain(trainId, groupLink) {
      let self = this;
      this.$confirm('是否确认报名？', '提示', {
        confirmButtonText: '确认并加群',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrainIntegrate", {
          trainId: trainId,
        }).then((res) => {
          var result = res.data;
          if (result.success) {
            self.getTrainList();
            //加群二维码图片
            this.dimensional = true
            this.jumpGroupLink = result.data.groupLink
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        }
        );
      }).catch(() => { })
    },
    //场景列表切换到场次列表
    toTrainList() {
      window.location.href =
        "/tjkStudy/train/index?type=" +
        this.tabType +
        "&tabMajorId=" +
        this.tabMajorId +
        "&show=yes";
    },
  },
};
</script>

<style lang="less" scoped>
.description {
  padding-bottom: 10px;
}

.scene .box {
  position: relative;
}

.box .text {
  width: 100%;
}

.test-button {
  position: absolute;
  margin-top: 10px;
  z-index: 999;
  bottom: 20px;
}

.isred {
  color: #E53434;
  margin-right: 10px;
  font-weight: 500;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #E53434;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 4px;
  background: #FBE5E5;
  line-height: 16px;
  height: 18px;
}

.isgreen {
  color: #14C034;
  margin-right: 10px;
  font-weight: 500;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #39CA54;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 4px;
  background: #D9F4DE;
  line-height: 16px;
  height: 18px;
}

.isposition {
  position: absolute;
  right: 20px;
  top: 5px;
}

.istext {
  width: 90%;
}

.Signinstyle {
  align-self: flex-end;
  display: inline-block;
  font-size: 16px;
  margin-left: 20px;
}

.Signinblue {
  color: #4a7bea;
  font-weight: 600;
}

.Signingreen {
  color: #5dc998;
  font-weight: 600;
}

.train-list {
  position: relative;
}

.buttonst {
  background: #5dc998 !important
}

.buttonsb {
  background: #4a7bea !important
}

.Sign_in {
  color: #4978fb;
  position: absolute;
  right: 30px;
  font-weight: 600;
  font-size: 16px;
}

.noSign_in {
  color: #53cb95;
  position: absolute;
  right: 30px;
  font-weight: 600;
  font-size: 16px;
}

.isnoSign_in {
  color: #53cb95;
  position: absolute;
  right: 30px;
  font-weight: 600;
  font-size: 16px;
}

.Training_failed {
  color: red;
  position: absolute;
  right: 30px;
  font-weight: 600;
  font-size: 16px;
}

.Invalid {
  color: red;
  position: absolute;
  right: 30px;
  font-weight: 600;
  font-size: 16px;
}

.train-list_position {
  position: relative;
}

.train-list_position .title {
  font-size: 18px !important;
}

.Entry_training {
  background: #5dc998 !important;
}

.button_box {
  margin-top: 30px !important;
}

.button_box>span {
  font-size: 16px;
  line-height: 35px !important;
  height: 37px !important;
}

.title_style {
  font-size: 16px;
  font-weight: 600;
}

.Badge_result_page {
  text-align: center;
}

.img_style {
  width: 50%;
}

.result-txt {
  font-size: 18px;
  color: #000;
  text-align: center;
}

.content_style {
  color: #000;
  font-size: 18px;
  text-align: center;
}

.button_primary {
  text-align: center;
  margin-top: 50px;
}

.button_again {
  background-color: #d3d5d7 !important;
  color: #898a8c !important;
}

.colorstylr {
  margin-right: 10px;
}

.button_box_true>span {
  margin-left: 50%;
  transform: translateX(-50%);
}

/deep/.el-dialog__footer {
  padding: 10px 20px 10px 20px;
}

/deep/.el-dialog {
  border-radius: 10px;
}

.systemPopup /deep/.el-dialog {
  width: 21% !important;
}

.systemPopup /deep/.el-dialog__header {
  padding: 5px 20px 5px 10px;
}

.dimensionalimg_text {
  text-align: center;
  font-size: 14px;
  font-weight: 600px;
  margin-top: 10px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
}

.dimensionalimg_Line {
  width: 100%;
  background: #F4F4F5;
  height: 2px;
}

.dimensionalimg_box /deep/.el-dialog--center .el-dialog__body {
  padding: 25px 0px 30px;
}

.dimensionalimg_box /deep/.el-dialog__footer {
  padding: 10px 20px 23px 20px
}

/deep/ .el-tabs__nav-wrap::after {
  background: #fff;
}

/deep/ .el-icon-house {
  margin-right: 6px;
}

/deep/ .el-icon-message {
  margin-right: 6px;
}

.el-tabs__active-bar {
  width: 124px;
}

.tabBox {
  margin-top: 14px;
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 14px;
  display: flex;
  background: #F5F6F7;
}

.index_tabBox {
  color: #497AF2;
  font-weight: 550;
  border: 1px solid #1684FC;
  border-right: 0px;
  text-align: center;
  padding: 3px 21px;
  background: #fff;
  font-size: 14px;
  cursor: pointer;
}

// .index_tabBox_left{color: #497AF2 ;font-weight: 550;border: 1px solid #1684FC;border-left:0px ; width: 100px;text-align: center;padding: 3px 0;background: #fff;font-size: 14px;cursor: pointer}
.index_tabBox_left {
  color: #497AF2;
  font-weight: 550;
  border: 1px solid #1684FC;
  text-align: center;
  padding: 3px 21px;
  font-size: 14px;
  cursor: pointer
}

.index_tabBox_after {
  color: #fff !important;
  background: #497AF2;
}

.right_listleft {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}

.right_listleft>.pass {
  margin-left: 10px;
  color: #6cc080;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #6cc080;
  border-radius: 5px;
  background: #d3f6d3;
}

.right_listleft>.failed {
  margin-left: 10px;
  color: #e15062;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #e15062;
  border-radius: 5px;
  background: #ffe3e2;
}

.right_listright {
  background: #1684fc;
  color: #fff;
  padding: 5px 20px;
  border-radius: 7px;
  cursor: pointer;
}

.right_under {
  background: #f6f5f8;
  padding: 10px 20px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 13px;
}

.right_under>div {
  overflow: hidden;
  height: 60px;
}

.content {
  display: block !important;
}

.right-top {
  display: flex;
  justify-content: space-between;
}

.circle {
  width: 20px;
  height: 20px;
  background: #497AF2;
  border-radius: 20px;
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s ease-out;
  // top: 75px;
  top: 65px;
  left: 10px;
  color: #fff;
  line-height: 20px;
}

.boxstyle {
  width: 100% !important;
}

.boxstyle>.title {
  justify-content: left !important;
}

.isposition /deep/.el-button--small {
  border-radius: 6px;
  height: 31px;
  line-height: 10px;
  letter-spacing: 1px;
  width: 101px;
  text-align: center;
  padding: 5px 20px;
  font-size: 14px;
}

.isposition /deep/.el-button--small>span {
  letter-spacing: 1px;
}

.textstyle {
  margin-top: 10px;
  background: #f5f6f7;
  border-radius: 5px;
  padding: 20px;
  font-size: 13px;
  overflow: hidden;
  height: auto !important;
}

.lock {
  background: url('../../assets/images/lock.png') no-repeat center;
  background-size: cover;
  width: 22px;
  height: 22px;
  position: absolute;
  right: 20px;
}

.otherline {
  width: 2px;
  top: 85px;
  bottom: -20px;
  left: 29px;
  position: absolute;
  border-color: inherit;
  background-color: #BBBBBB;
  z-index: 99;
}

.othercircle {
  width: 20px;
  height: 20px;
  background: #BBBBBB;
  border-radius: 20px;
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s ease-out;
  // top: 75px;
  top: 65px;
  line-height: 20px;
  color: #fff;
}

.RegistrationSessions {
  background: #fff;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 20px;
  padding: 0px 0 20px 0;
  position: relative;
  overflow: hidden;
}

.RegistrationSessions .label {
  background: #497AF2;
  display: inline-block;
  color: #fff;
  border-radius: 10px 0px 10px 0px;
  width: 100px;
  height: 34px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 35px;
  text-align: center;
}

.text_box {
  padding: 0 20px;
}

.title_state_button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 20px;
}

.title_state {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #262626;
  ;
  display: flex;
}

.Reg_button {
  background: #497AF2;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  cursor: pointer;
  letter-spacing: 1px;
}

.special_button {
  background: #14C034;
}

/*直播模式：已签到文案（卡片右上角）*/
.live_signed_badge {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #14C034;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 20px;
}

/*直播模式：操作按钮行（卡片右下角）*/
.live_btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.Reg_isred {
  color: #E53434;
  margin-right: 9px;
  font-weight: 500;
  font-size: 12px;
  padding: 0px 3px;
  margin-left: 9px;
  margin-top: 6px;
  height: 23px;
  background: #FBE5E5;
  border: 1px solid #E53434;
  border-radius: 4px;
  height: 18px;
  line-height: 15px;
}

.Reg_isgreen {
  color: #14C034;
  margin-right: 9px;
  font-weight: 500;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #39CA54;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 6px;
  background: #D9F4DE;
  height: 18px;
  line-height: 15px;
}

.Reg_date,
.Reg_time,
.Reg_lecturer {
  color: #262626;
  font-size: 14px;
  margin-bottom: 5px;
}

.Reg_time {
  width: 500px;
}

.Reg_qq {
  color: #262626;
  font-size: 14px;
}

.Reg_content {
  margin-top: 12px;
  background: #f5f6f7;
  padding: 20px;
}

.index_tabbox_0 {
  border-radius: 4px 0px 0px 4px;
}

.index_tabbox_last {
  border-radius: 0px 4px 4px 0px;
  color: #497AF2;
  font-weight: 550;
  border: 1px solid #1684FC;
  border-left: 0;
  text-align: center;
  padding: 3px 21px;
  font-size: 14px;
  cursor: pointer
}

/deep/.el-tabs__header {
  margin: 0px !important;
  padding-left: 20px !important;
}

.dialog_img {
  width: 85px;
  height: 64px;
  margin: 0 auto;
}

.dialog_img>img {
  width: 360px;
  height: 100%;
}

.qq_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
  text-align: center;
  margin-top: 14px;
}

.currency_button {
  display: flex;
  justify-content: center;
}

.determine {
  width: 80px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.cancel {
  width: 80px;
  height: 28px;
  background: #E1E1E1;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #717171;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  margin-right: 10px;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 18px 0 0 0;
}

.cel-button {
  margin: 0 auto;
  width: 100px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 30px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.fail_img {
  font-size: 14px;
  color: #EE3F3F;
  font-weight: 500;
  display: flex;
  position: absolute;
  right: 20px;
  top: 80px;
}

.fail_img>img {
  margin-right: 6px;
}

.Reg_button_isqian {
  width: 100px;
  height: 28px;
  background: #DBE5FF;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #497AF2;
  text-align: center;
  line-height: 28px;
}

.Reg_button_noqian {
  width: 100px;
  height: 28px;
  background: #E1E1E1;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ABABAB;
  text-align: center;
  line-height: 28px;
}

.thespan {
  color: #E53434;
}

.typingCertification {
  background: #FFFFFF;
  border-radius: 10px;
  ;
  padding: 19px 20px 21px 0;
}

.typing_top {
  display: flex;
}

.typing_title {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
  margin-left: 19px;
  margin-bottom: 19px;
}

.typing_state {
  color: #E53434;
  margin-right: 10px;
  font-weight: 500;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #E53434;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 4px;
  background: #FBE5E5;
  line-height: 16px;
  height: 18px;
}

.typing_bottom {
  background: #F5F6F7;
  padding: 20px 110px 20px 20px;
  margin-left: 20px;
}

.top_line {
  position: absolute;
  top: 0;
  left: 29px;
  width: 2px;
  height: 65px;
}

.top_isCheck {
  background: #1684fc;
}

.top_noCheck {
  background: #BBBBBB;
}

.other-list {
  height: auto !important;
}

.Lvone_tab {
  margin: 13px 19px 0 19px;
  display: flex;
}

.Onetabtext {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  margin-right: 39px;
  padding-bottom: 13px;
  cursor: pointer;
}

.Onetabtext_1 {
  color: #497AF2;
  border-bottom: 2px solid #497AF2;
}

.index_tabbox_fristss {
  border: 1px solid #497AF2;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/index.vue